// Login.js

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import { useState } from "react";
import titleZedLogo from "./title-zedlogo.png";
import Card from "react-bootstrap/Card";

function ForgotPassword() {
  const handleKeyDown = async () => {
    await duoPreauth("tuser@zedcloud.com.au");
  };

  async function duoPreauth(username) {
    fetch("/api/v1/forgot-password", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username }),
    })
      .then((response) => response.json())
      .then((json) => {
        //setShowForm(false);
        //loadPatientForms();
      })
      .catch((err) => {
        console.log(
          "[ERROR] An error occured while calling /api/v1/forgot-password",
          err,
        );
      });
  }

  //const handleSubmit = (userName) => {};

  return (
    <div className="container text-center p-4">
      <Button
        variant="primary"
        type="button"
        onClick={() => handleKeyDown()}
        style={{ width: 440, height: 40 }}
      >
        Change Password
      </Button>
    </div>
  );
}

export default ForgotPassword;
